<template>
  <div id="body1" class="mt-n6">
    <div>
      <!-- <v-row class="mt-10 ml-5">
        <v-toolbar>
          <v-toolbar-title>
            <h3 class="primary--text" style="font-family: monospace">
              <b>Referrer Details</b>
            </h3>
          </v-toolbar-title>
        </v-toolbar>
      </v-row> -->
      <v-row class="ma-5">
        <v-col cols="12" sm="12" xl="12" lg="12" md="12" class="mt-8">
          <v-row>
            <v-col cols="12" sm="12" xl="6" lg="6" md="6">
              <div data-aos="flip-right">
                <v-card height="350" flat>
                  <v-row style="margin-top: 40px">
                    <v-col cols="12" sm="8" xl="8" lg="8" md="8" class="mt-1">
                      <span class="ml-3 grey--text" style="font-size: 20px"
                        >Referrer Name</span
                      ><br />
                      <span class="ml-3 black--text" style="font-size: 17px">
                        {{ DashboardItem.user_name }}</span
                      >
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1"></v-col>
                    <v-col cols="12" sm="2" xl="2" lg="2" md="2" class="mt-1">
                      <v-card
                        height="60"
                        elevation="1"
                        rounded="xl"
                        class="mr-2 primary"
                      >
                        <div class="layout column align-center">
                          <v-icon class="mt-4 goldd">mdi-account-tie</v-icon>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-4 mb-2"></v-divider>
                  <v-row>
                    <v-col cols="12" sm="8" xl="8" lg="8" md="8" class="mt-1">
                      <span class="ml-3 grey--text" style="font-size: 20px"
                        >Referrer Email</span
                      ><br />
                      <span class="ml-3 black--text" style="font-size: 17px">
                        {{ DashboardItem.email_id }}</span
                      >
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1"></v-col>
                    <v-col cols="12" sm="2" xl="2" lg="2" md="2" class="mt-1">
                      <v-card
                        height="60"
                        elevation="1"
                        rounded="xl"
                        class="mr-2 primary"
                      >
                        <div class="layout column align-center">
                          <v-icon class="mt-4 goldd">mdi-email</v-icon>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-divider class="mt-4 mb-2"></v-divider>
                  <v-row>
                    <v-col cols="12" sm="8" xl="8" lg="8" md="8" class="mt-1">
                      <span class="ml-3 grey--text" style="font-size: 20px"
                        >Referrer Contact Number</span
                      ><br />
                      <span class="ml-3 black--text" style="font-size: 17px">
                        {{ DashboardItem.mobile_number }}</span
                      >
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1"></v-col>
                    <v-col cols="12" sm="2" xl="2" lg="2" md="2" class="mt-1">
                      <v-card
                        height="60"
                        elevation="1"
                        rounded="xl"
                        class="mr-2 primary"
                      >
                        <div class="layout column align-center">
                          <v-icon class="mt-4 goldd">mdi-phone</v-icon>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>
            <v-col cols="12" sm="12" xl="6" lg="6" md="6">
              <div data-aos="flip-right">
                <v-card height="350" flat>
                  <v-row style="margin-top: 40px">
                    <v-col cols="12" sm="8" xl="8" lg="8" md="8" class="mt-1">
                      <span class="ml-3 grey--text" style="font-size: 20px"
                        >Corporate Name</span
                      ><br />
                      <span class="ml-3 black--text" style="font-size: 17px">
                        {{ DashboardItem.corp_name }}
                      </span>
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1"></v-col>
                    <v-col cols="12" sm="2" xl="2" lg="2" md="2" class="mt-1">
                      <v-card
                        height="60"
                        elevation="1"
                        rounded="xl"
                        class="mr-2 primary"
                      >
                        <div class="layout column align-center">
                          <v-icon class="mt-4 goldd"
                            >mdi-office-building-plus-outline</v-icon
                          >
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="mt-4 ml-n2"
                            color="primary"
                            large
                            v-on="on"
                            @click="routetoView1()"
                            >mdi-arrow-right-thin</v-icon
                          >
                        </template>
                        <span>view more</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-4 mb-2"></v-divider>
                  <v-row>
                    <v-col cols="12" sm="8" xl="8" lg="8" md="8" class="mt-1">
                      <span class="ml-3 grey--text" style="font-size: 20px"
                        >Subscribed Pack</span
                      ><br />
                      <span class="ml-3 black--text" style="font-size: 17px">
                        {{ DashboardItem.pack_name }}
                      </span>
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1"></v-col>
                    <v-col cols="12" sm="2" xl="2" lg="2" md="2" class="mt-1">
                      <v-card
                        height="60"
                        elevation="1"
                        rounded="xl"
                        class="mr-2 primary"
                      >
                        <div class="layout column align-center">
                          <v-icon class="mt-4 goldd"
                            >mdi-gift-open-outline</v-icon
                          >
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="mt-4 ml-n2"
                            color="primary"
                            large
                            v-on="on"
                            @click="routetoView2()"
                            >mdi-arrow-right-thin</v-icon
                          >
                        </template>
                        <span>view more</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>

                  <v-divider class="mt-4 mb-2"></v-divider>
                  <v-row>
                    <v-col cols="12" sm="8" xl="8" lg="8" md="8" class="mt-1">
                      <span class="ml-3 grey--text" style="font-size: 20px"
                        >Total Commission Earned</span
                      ><br />
                      <span class="ml-3 black--text" style="font-size: 17px">
                        {{ DashboardItem.total_commision }} MYR</span
                      >
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1"></v-col>
                    <v-col cols="12" sm="2" xl="2" lg="2" md="2" class="mt-1">
                      <v-card
                        height="60"
                        elevation="1"
                        rounded="xl"
                        class="mr-2 primary"
                      >
                        <div class="layout column align-center">
                          <v-icon class="mt-4 goldd"
                            >mdi-hand-coin-outline</v-icon
                          >
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" xl="1" lg="1" md="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="mt-4 ml-n2"
                            color="primary"
                            large
                            v-on="on"
                            @click="routetoView3()"
                            >mdi-arrow-right-thin</v-icon
                          >
                        </template>
                        <span>view more</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col cols="12" sm="12" xl="12" lg="12" md="12">
              <v-card height="auto" elevation="1" rounded="xl" outlined>
                <v-toolbar flat>
                  <v-toolbar-title>
                    <h4 class="primary--text" style="font-family: monospace">
                      <b>Referred Corporate Details</b>
                    </h4>
                  </v-toolbar-title>
                </v-toolbar>

                <v-col cols="12" sm="12" xl="12" lg="12" md="12">
                  <v-data-table
                    :headers="headers"
                    :items="tableItems"
                    dense
                    hide-default-footer
                    class="mt-n3"
                    :no-data-text="NOdata"
                  >
                  </v-data-table>
                </v-col>
              </v-card>
            </v-col>
          </v-row> -->
        </v-col>
      </v-row>
      <!-- <v-row class="ma-5"> -->
      <!-- <v-col cols="12" sm="6" xl="6" lg="6" md="6">
          <v-card height="300" elevation="1" rounded="xl">
            <v-img src="@/assets/apexcharttt.png" height="300"></v-img>
          </v-card>
        </v-col> -->

      <!-- <v-col cols="12" sm="12" xl="6" lg="6" md="6">
          <v-card height="300" elevation="1" rounded="xl">
            <v-img src="@/assets/apexnew.png" height="300"></v-img>
          </v-card>
        </v-col> -->
      <!-- </v-row> -->
    </div>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    tableItems: [],
    headers: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
        width: "1px",
      },
      {
        text: "CORP NAME",

        width: "2px",
        sortable: false,
      },

      {
        text: "ONBOARDED ON",

        align: "start",
        width: "2px",

        sortable: false,
      },

      {
        text: "STATUS",

        align: "start",
        width: "3px",

        sortable: false,
      },
    ],
    NOdata: "WORK IN PROGRESS",
    DashboardItem: {},
  }),
  mounted() {
    this.dashboardData();
  },
  methods: {
    async dashboardData() {
      var inputData = {
        method_name: "REFERRE",
        page_no: this.pageCount,
        record_count: 0,
        page_size: 50,
        app_code: "CPORTAL",
        method_param: {
          action: "DSHCOUNT",
          ref_id: this.$store.getters.get_getRefDetails.user_id,
        },
      };

      var responseData = await apiCall(inputData);

      this.DashboardItem = responseData.data.data[0];
    },
    routetoView1() {
      this.$router.push("/ViewCorp");
    },
    routetoView2() {
      this.$router.push("/RefCommission");
    },
    routetoView3() {
      this.$router.push("/RefCommission");
    },
  },
};
</script>
<style>
.goldd {
  background: linear-gradient(to bottom, #be9752, #dbb973 50%, #be9752);
}
#body1 {
  height: 100%;
  width: 100%;
  /* position: fixed; */

  background: #ffff;
}
</style>
